require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./stucture-des-tudes-de-doctorat-2-3-0.json") })
        }
      }, "path---stucture-des-tudes-de-doctorat-2-3-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---stucture-des-tudes-de-doctorat-2-3-0!./.cache/json/stucture-des-tudes-de-doctorat-2-3-0.json
// module id = 580
// module chunks = 231608221292675